<template>
  <div>
    <div class="mb-2">
      <b-button
        variant="bg-primary"
        @click="$router.push({ name: 'add-lifecycle', params: { accountId } })"
      >
        <GjIcon
          class="icon-left"
          name="Plus"
        />
        Create Lifecycle
      </b-button>
    </div>
    <div
      v-if="!fetchingLifecycles"
      class="default-table m-0 border-none shadow-none"
    >
      <b-table
        ref="table"
        class="loaded"
        table-class="m-0 p-0"
        :items="lifecycles"
        :fields="fields"
        :busy="
          fetchingLifecycles ||
            addingLifecycle ||
            updatingifecycle ||
            deletingifecycle
        "
        responsive
      >
        <template #cell(id)="data">
          <a
            class="text-primary"
            @click="edit(data.item.id)"
          >
            {{ data.value }}
          </a>
        </template>
        <template #cell(expiration)="data">
          <div class="d-flex">
            <span v-if="data.value.days">
              {{ data.value.days }} {{ data.value.days === 1 ? 'day' : 'days' }}
            </span>
            <a
              class="ml-auto"
              @click="edit(data.item.id)"
            >
              <GjIcon name="Edit" />
            </a>
            <a
              style="margin-left:5px;"
              @click="remove(data.item)"
            >
              <GjIcon name="Delete" />
            </a>
          </div>
        </template>
      </b-table>
      <div class="px-1 mt-1">
        <a
          class="text-primary text-medium"
          @click="$router.push({ name: 'add-lifecycle', params: { accountId } })"
        >
          + Add lifecycle
        </a>
      </div>
    </div>
    <loading-page v-else />
  </div>
</template>

<script>
export default {
  name: 'BucketLifecycle',
  components: {},
  data() {
    return {
      fields: ['id', 'status', 'expiration'],
      bucketId: null,
      items: [],
      accountId: 0,
    }
  },
  computed: {
    fetchingLifecycles() {
      return this.$store.state.accountLifecycle.fetchingLifecycles
    },
    lifecycles() {
      return this.$store.state.accountLifecycle.lifecycles
    },
    addingLifecycle() {
      return this.$store.state.accountLifecycle.addingLifecycle
    },
    updatingifecycle() {
      return this.$store.state.accountLifecycle.updatingifecycle
    },
    deletingifecycle() {
      return this.$store.state.accountLifecycle.deletingifecycle
    },
    gettingLifecycle() {
      return this.$store.state.accountLifecycle.gettingLifecycle
    },
    bucketName() {
      return this.$route.params.id
    },
  },
  created() {
    this.accountId = this.$route.params.accountId
    this.bucketId = this.$route.params.id
    this.fetchLifecycles()
  },
  methods: {
    fetchLifecycles() {
      this.$store
        .dispatch('accountLifecycle/fetchLifecycles', {
          accountId: this.accountId,
          name: this.bucketName,
        })
        .catch(() => this.errorToast(
          'An error occurred, while fetching lifecycles.',
        ))
    },
    remove(val) {
      this.confirmDelete(
        'Remove Lifecycle Configuration',
        `Are you sure you want to remove "${val.id}"?`,
        'Remove',
      ).then(ok => {
        if (ok) {
          this.$store
            .dispatch('accountLifecycle/deleteLifecycle', {
              accountId: this.accountId,
              query: {
                bucketName: this.bucketId,
                id: val.id,
              },
            })
            .then(() => {
              this.successToast('Lifecycle successfully removed!')
              this.fetchLifecycles()
            })
            .catch(error => this.errorToast(
                error.response?.data?.errors[0]
                  || "An error occurred, couldn't delete lifecycle configuration.",
            ))
        }
      })
    },
    edit(id) {
      this.$router.push({
        name: 'edit-lifecycle',
        params: { id: this.bucketId, lifecycleId: id },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.default-table::v-deep {
  margin-bottom: 0;
  .table {
    border-bottom: none;
    tbody {
      tr:nth-child(1) {
        td {
          padding-top: 16px;
        }
      }
      td {
        padding-top: 8px;
        padding-bottom: 8px;
        box-sizing: border-box;
      }
    }
  }
}
</style>
